import { render, staticRenderFns } from "./form_start_monetization_component.vue?vue&type=template&id=99068e98&scoped=true"
import script from "./form_start_monetization_component.vue?vue&type=script&lang=js"
export * from "./form_start_monetization_component.vue?vue&type=script&lang=js"
import style0 from "./form_start_monetization_component.vue?vue&type=style&index=0&id=99068e98&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99068e98",
  null
  
)

export default component.exports